import React from 'react';
import { ICareTeamAssignmentPreview } from '@liquid-state/pephealth-client';
import {
  formatCareTeamAssignmentPathwayLabel,
  formatCareTeamAssignmentPatientLabel,
} from '@utils/careTeamAssignmentPreviewLabels';

type Translate = (key: string, options?: Record<string, unknown>) => string;

type CareTeamAssignmentImpactContentProps = {
  assignments: ICareTeamAssignmentPreview[];
  t: Translate;
};

export default function CareTeamAssignmentImpactContent({
  assignments,
  t,
}: CareTeamAssignmentImpactContentProps) {
  return (
    <div className="care-team-assignment-impact">
      <p>{t('common:careTeamAssignmentImpact.description')}</p>
      <ul>
        {assignments.map(assignment => {
          const pathway = formatCareTeamAssignmentPathwayLabel(assignment);
          return (
            <li key={assignment.careTeamMemberId}>
              <div>
                {t('common:careTeamAssignmentImpact.role', {
                  name: assignment.roleName,
                  description: assignment.roleDescription,
                })}
              </div>
              <div>
                {t('common:careTeamAssignmentImpact.patient', {
                  patient: formatCareTeamAssignmentPatientLabel(assignment),
                })}
              </div>
              {pathway ? (
                <div>
                  {t('common:careTeamAssignmentImpact.pathway', {
                    pathway,
                  })}
                </div>
              ) : null}
            </li>
          );
        })}
      </ul>
    </div>
  );
}
